import type { Logger } from "./types";

/**
 * Noop implements the Logger interface and performs no logging.
 */
export class Noop implements Logger {
  error(
    _errCode: string,
    _caller: string,
    _message: string,
    _error?: unknown,
    _optionalParams?: Record<string, unknown>
  ): void {
    return;
  }

  info(_caller: string, _message: string, _optionalParams?: Record<string, unknown>) {
    return;
  }

  warn(_caller: string, _message: string, _optionalParams?: Record<string, unknown>) {
    return;
  }
}
